import { getCurrency } from "./side_effects";
import { CurrenciesState, defaultCurrency } from "./types";

export const currencyPersistedState = (): CurrenciesState => ({ selectedCurrency: getCurrency() || defaultCurrency });
